<template>
  <donut-chart08-template
    :board-ids="[108, 156, 157, 158, 159]"
    :data-type="dataType"
    field-code="facility"
    :graph-id="53"
    title="(시설물) 유해·위험요인 조사 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart53',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
